module.exports = __webpack_public_path__ + "img/LINKEDIN.80819046.svg";